function doMath() {
  const locations = (<HTMLInputElement>document.getElementById("num1")).value;
  let dollarsInput = <HTMLInputElement>document.getElementById("dollars");
  let invoicesInput = <HTMLInputElement>document.getElementById("invoices");
  const dollars: number = 6084 * parseInt(locations);
  let invoices: number = 8.4 * parseInt(locations);
  invoices = Math.round(invoices);

  const formatter = new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
  });

  if (!isNaN(dollars)) {
    dollarsInput.innerText = formatter.format(dollars);
    invoicesInput.innerText = String(invoices);
  }
}

const container: any = document.querySelector(".bopis-calculator");

if (container) {
  const calculatorSubmit = <HTMLInputElement>(
    document.getElementById("calculator-submit")
  );

  calculatorSubmit.addEventListener("click", (e) => {
    e.preventDefault();
    doMath();
  });
}
